// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__weveK","header":"Messages_header__HZmqk"};